import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Constants } from "../constants";
import { parse, format, AsYouType } from "libphonenumber-js";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;
@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.css"],
})
export class ReportsComponent implements OnInit {
  reportsList: any[];
  bsConfig: Partial<BsDatepickerConfig>;
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  customerData: any;
  searcAllInput: any;
  page2 = 0;
  outlet_id: any;
  last_page2: any;
  dispensary_id: any;
  businessName: any;
  limit2: any;
  format: any;
  nao = new Nanobar();
  driverData: any;
  onlineDrivers = new Array();
  offlineDrivers = new Array();
  page = 0;
  last_page: any;
  limit: any;
  paginatedData: any;
  searchTimeOut: any;
  paginatedData2: any;
  paginatedData3: any;
  btnShowAfterDataLoad = false;
  dispensaryData: any;
  dispensaryDetails: any;
  servicedetail: any;
  last_page3: any;
  page3 = 0;
  areaData: any;
  cityList: any;
  Paginationdisable: any;
  categoryData: any;
  serviceCity: string;
  myDateValue: any;
  applyFilterBtn: boolean = false;
  serviceArea: any;
  categoryId: any;
  start_date: any;
  end_date: any;
  serviceAreaText: string = "Service Area";
  categoryText: string = "Category";
  today: Date;
  filterType: any = -1;
  filteredData: any;
  searchBusiness: any;
  orderHistory: any;
  total_platform_fee: any;
  showSearchResults: boolean = false;
  searchBusinessDetailforOrder: Object;
  total_deliverey_charges: any;
  lastPage: any;
  noFilter: boolean = true;
  checkbox: any;
  paginated: any;
  pageHistory: number = 0;
  constructor(private dataService: DataService) {
    this.today = new Date();
    if (window.localStorage.getItem("isauthenticated") !== "true") {
      window.location.href = "/";
    }
  }
  customerslist() {
    this.nao.go(30);
    this.customerData = [];
    this.dataService
      .getCustomersReport(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.customerData = data;
          if (this.customerData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.customerData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.customerData.rest_error_code === 4)
            toastr.error("Doest not exist");
          this.limit2 = 2;
          this.last_page2 = this.customerData.last_page;

          this.page2++;
          this.customerData = this.customerData.items;
          this.btnShowAfterDataLoad = true;
        },
        (error) => {
          this.nao.go(100);

          toastr.error("Some thing went wrong");
        }
      );
  }
  getCustomersListByPageFunction() {
    this.nao.go(30);

    this.dataService
      .getCustomersReportByPage(
        window.localStorage.getItem("token"),
        this.page2
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.page2++;
          this.paginatedData2 = data;
          // this.limit = this.paginatedData.limit;
          this.last_page2 = this.paginatedData2.last_page;
          this.paginatedData2 = this.paginatedData2.items;

          for (var i = 0; i < this.paginatedData2.length; i++) {
            this.customerData.push(this.paginatedData2[i]);
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService
        .getdispensaryListingById(
          localStorage.getItem("token"),
          this.serviceCity,
          this.searchBusiness
        )
        .subscribe(
          (data) => {
            this.showSearchResults = true;
            this.searchBusinessDetailforOrder = data;
          },
          (error) => {
            console.log("error", error);
            toastr.error("Some thing went wrong");
          }
        );
    });
  }

  driverlist() {
    // this.nao.go(30);

    this.dataService
      .getDriverReport(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);

          this.driverData = data;
          if (this.driverData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.driverData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.driverData.rest_error_code === 4)
            toastr.error("Doest not exist");
          this.last_page = this.driverData.last_page;
          this.page++;
          this.limit = 2;
          this.driverData = this.driverData.items;
          this.btnShowAfterDataLoad = true;
          for (var i = 0; i < this.driverData.length; i++) {
            if (this.driverData[i].is_online === true) {
              this.onlineDrivers.push(this.driverData[i]);
            } else {
              this.offlineDrivers.push(this.driverData[i]);
            }
            if (this.driverData[i].country_code === "+1") {
              this.driverData[i].number = format(
                this.driverData[i].number,
                "US",
                "NATIONAL"
              );
            }
          }
        },
        (error) => {
          // this.nao.go(100);

          toastr.error("Some thing went wrong");
        }
      );
  }
  getDriverListByPageFunction() {
    this.nao.go(30);

    this.dataService
      .getDriversReportByPage(window.localStorage.getItem("token"), this.page)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginatedData = data;
          // this.limit = this.paginatedData.limit;
          this.last_page = this.paginatedData.last_page;
          this.paginatedData = this.paginatedData.items;

          this.page++;
          for (var i = 0; i < this.paginatedData.length; i++) {
            this.driverData.push(this.paginatedData[i]);
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  getDispensaryReportFunction() {
    // this.nao.go(30);

    this.dataService
      .getDispensaryReport(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.dispensaryData = data;
          this.last_page3 = this.dispensaryData.last_page;
          this.page3++;
          this.dispensaryData = this.dispensaryData.items;
        },
        (error) => {
          // this.nao.go(100);

          toastr.error("Some thing went wrong");
        }
      );
  }
  getDispensaryListByPageFunction() {
    this.nao.go(30);
    this.dataService
      .getDispensaryReportByPage(
        window.localStorage.getItem("token"),
        this.page3
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginatedData3 = data;
          // this.limit = this.paginatedData.limit;
          this.last_page3 = this.paginatedData3.last_page;
          this.paginatedData3 = this.paginatedData3.items;

          this.page3++;
          for (var i = 0; i < this.paginatedData3.length; i++) {
            this.dispensaryData.push(this.paginatedData3[i]);
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  csvGenerateCustomer() {
    let csv;
    for (let row = 0; row < this.customerData.length; row++) {
      let keysAmount = Object.keys(this.customerData[row]).length;
      let keysCounter = 0;
      if (row === 0) {
        for (let key in this.customerData[row]) {
          csv += key + (keysCounter + 1 < keysAmount ? "," : "\r\n");
          keysCounter++;
        }
      } else {
        for (let key in this.customerData[row]) {
          csv +=
            this.customerData[row][key] +
            (keysCounter + 1 < keysAmount ? "," : "\r\n");
          keysCounter++;
        }
      }
      keysCounter = 0;
    }
    // Once we are done looping, download the .csv by creating a link
    let link = document.createElement("a");
    link.id = "download-csv-customer";
    link.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(csv)
    );
    link.setAttribute("download", "customers.csv");
    document.body.appendChild(link);
    // document.querySelector('#download-csv-customer')[0].click();
    window.setTimeout(function () {
      document.getElementById("download-csv-customer").click();
    }, 1000);
  }
  csvGenerateDriver() {
    let csv;
    // Loop the array of objects
    for (let row = 0; row < this.driverData.length; row++) {
      let keysAmount = Object.keys(this.driverData[row]).length;
      let keysCounter = 0;
      // If this is the first row, generate the headings
      if (row === 0) {
        // Loop each property of the object
        for (let key in this.driverData[row]) {
          // This is to not add a comma at the last cell
          // The '\r\n' adds a new line
          csv += key + (keysCounter + 1 < keysAmount ? "," : "\r\n");
          keysCounter++;
        }
      } else {
        for (let key in this.driverData[row]) {
          csv +=
            this.driverData[row][key] +
            (keysCounter + 1 < keysAmount ? "," : "\r\n");
          keysCounter++;
        }
      }
      keysCounter = 0;
    }
    // Once we are done looping, download the .csv by creating a link
    let link = document.createElement("a");
    link.id = "download-csv-driver";
    link.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(csv)
    );
    link.setAttribute("download", "driver.csv");
    document.body.appendChild(link);
    // document.querySelector('#download-csv-driver')[0].click();
    window.setTimeout(function () {
      document.getElementById("download-csv-driver").click();
    }, 1000);
  }
  csvGenerateDispensary() {
    let csv;
    for (let row = 0; row < this.dispensaryData.length; row++) {
      let keysAmount = Object.keys(this.dispensaryData[row]).length;
      let keysCounter = 0;
      if (row === 0) {
        for (let key in this.dispensaryData[row]) {
          csv += key + (keysCounter + 1 < keysAmount ? "," : "\r\n");
          keysCounter++;
        }
      } else {
        for (let key in this.dispensaryData[row]) {
          csv +=
            this.dispensaryData[row][key] +
            (keysCounter + 1 < keysAmount ? "," : "\r\n");
          keysCounter++;
        }
      }
      keysCounter = 0;
    }
    let link = document.createElement("a");
    link.id = "download-csv-dispensary";
    link.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(csv)
    );
    link.setAttribute("download", "dispensary.csv");
    document.body.appendChild(link);
    // document.querySelector('#download-csv-driver')[0].click();
    window.setTimeout(function () {
      document.getElementById("download-csv-dispensary").click();
    }, 1000);
  }

  ngOnInit() {
    this.getDispensaryListing();
    this.driverlist();
    this.customerslist();
    this.getDispensaryReportFunction();
    this.getServiceArea();
    this.getbusinessCategory();
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#reports").css("color", "#d77229");
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $("#sidebar").css("display", "block");
  }
  getServiceArea() {
    this.dataService
      .getservices(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.areaData = data;
          if (this.areaData.rest_error_code == 4) {
            this.cityList = this.areaData.city_list;
          } else {
          }
        },
        (error) => {}
      );
  }
  getbusinessCategory() {
    this.dataService
      .getBusinessCategory(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.categoryData = data;
        },
        (error) => {}
      );
  }
  serviceAreaChange(event) {
    if (event != -1) {
      this.serviceArea = event.city;
      this.serviceAreaText = event.city;
    } else {
      this.serviceArea = event;
      this.serviceAreaText = "All";
    }
    this.validApplyFilter("-1");
  }
  categoryChange(event) {
    if (event != -1) {
      this.categoryId = event.id;
      this.categoryText = event.name;
    } else {
      this.categoryId = event;
      this.categoryText = "All";
    }
    this.validApplyFilter("-1");
  }

  getDispensaryListing() {
    this.dataService
      .getdispensaryListing(localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.dispensaryDetails = data;
          this.businessName = "Business Name";
          // this.orderslist(this.status);
          this.servicedetail = data;
        },
        (error) => {
          // this.nao.go(100);

          toastr.error("Some thing went wrong");
        }
      );
  }

  applyFilters() {
    this.nao.go(30);
    this.noFilter = false;
    let page = 0;
    let limit = 40;
    let category_id = this.categoryId;
    let city_id = this.serviceArea;
    let filter_type = this.filterType;
    let start_date = this.start_date;
    let end_date = this.end_date;
    let total_platform_fee = this.total_platform_fee;
    let total_deliverey_charges = this.total_deliverey_charges;
    this.nao.go(70);
    this.dataService
      .getOrderHistory(
        window.localStorage.getItem("token"),
        category_id,
        city_id,
        page,
        limit,
        filter_type,
        this.dispensary_id,
        start_date,
        end_date,
        total_platform_fee,
        total_deliverey_charges
      )
      .subscribe((data) => {
        this.filteredData = data;
        this.orderHistory = this.filteredData.items;
        this.lastPage = this.filteredData.last_page;
      });
    this.nao.go(100);
  }
  validApplyFilter(event) {
    if (event != "-1") {
      this.start_date = event[0];
      this.start_date = this.formatDate(this.start_date);
      this.end_date = event[1];
      this.end_date = this.formatDate(this.end_date);
    }
    if (
      this.serviceArea != "" &&
      this.serviceArea != undefined &&
      this.categoryId != "" &&
      this.categoryId != undefined &&
      this.start_date != "" &&
      this.start_date != undefined &&
      this.end_date != "" &&
      this.end_date != undefined &&
      this.businessName != "Business Name" &&
      this.businessName != undefined
    ) {
      this.applyFilterBtn = true;
    } else {
      this.applyFilterBtn = false;
    }
  }
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  filterBusinessId(id, name, detail) {
    this.dispensary_id = id;
    this.businessName = name;
    this.validApplyFilter("-1");

    // this.getBusinessActivityFunction();
    // this.getActivityByPageFunction();

    // if (this.dispensary_id == -1) {
    //   this.businessName = "All Businesses";
    // }

    // if (this.dispensary_id != -1) {
    //   this.businessName = name;
    // }
  }

  businessDetailPopOpen(id) {
    this.reportsList = [];
    this.nao.go(30);
    $("#transactionDetailPop").modal("show");
    this.outlet_id = id;
    let page = 0;
    let limit = 40;
    let start_date = this.start_date;
    let end_date = this.end_date;
    this.dataService
      .getBusinessOrderHistory(
        window.localStorage.getItem("token"),
        page,
        limit,
        start_date,
        end_date,
        this.outlet_id
      )
      .subscribe(
        (data: any) => {
          this.reportsList = data.items;
          this.nao.go(100);
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  noOrderBusiness() {
    this.checkbox = <HTMLInputElement>document.getElementById("noOrder");
    if (this.checkbox.checked == true) {
      this.filterType = 0;
    } else {
      this.filterType = -1;
    }
  }
  orderHistoryPagination() {
    this.Paginationdisable = true;
    this.noFilter = false;
    this.paginated = [];
    this.pageHistory++;
    let limit = 40;
    let category_id = this.categoryId;
    let city_id = this.serviceArea;
    let filter_type = this.filterType;
    let start_date = this.start_date;
    let end_date = this.end_date;
    let total_platform_fee = this.total_platform_fee;
    let total_deliverey_charges = this.total_deliverey_charges;

    this.dataService
      .getOrderHistory(
        window.localStorage.getItem("token"),
        category_id,
        city_id,
        this.page,
        limit,
        filter_type,
        this.dispensary_id,
        start_date,
        end_date,
        total_platform_fee,
        total_deliverey_charges
      )
      .subscribe((data) => {
        this.filteredData = data;
        this.paginated = this.filteredData.items;
        this.Paginationdisable = false;
        if (this.paginated != "" && this.paginated != undefined) {
          for (let i = 0; i < this.paginated.length; i++) {
            this.orderHistory.push(this.paginated[i]);
          }
        }
        this.lastPage = this.filteredData.last_page;
      });
  }
  downloadCSV2() {
    let csvData = this.ConvertToCSV(this.reportsList, [
      "order_id",
      "client_name",
      "platform_fee",
      "delivery_charges",
      "total_amount",
      "order_status",
      "delivered_by",
    ]);

    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "order_histroy" + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadCSV() {
    let csvData = this.ConvertToCSV(this.orderHistory, [
      "business_name",
      "outlet_name",
      "outlet_address",
      "completed_order_count",
      "cancel_order_count",
      "return_order_count",
      "complete_order_amount",
      "total_platform_fee",
      "total_deliverey_charges",
    ]);

    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "order_histroy" + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    let row = "S.No,";

    for (let index in headerList) {
      row += headerList[index] + ",";
    }
    str += row + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + "";
      for (let index in headerList) {
        let head = headerList[index];

        if (array[i].outlet_address && array[i].complete_order_amount) {
          array[i].outlet_address = array[i].outlet_address.replace(",", "");
          array[i].complete_order_amount = array[
            i
          ].complete_order_amount.replace(",", "");
        }
        line += "," + array[i][head];
      }
      str += line + "\r\n";
    }

    return str;
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts